import { useState } from "react";
import { toast } from "react-toastify";
import { exportCameraTraps } from "@services/device/cameraTrap/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { CAMERA_TRAPS_EXPORT_HEADS } from "@typings/entities/devices/export";

export function useExportCameraTraps() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const response = await exportCameraTraps();

      if (!response.items?.length) {
        toast.warning(
          "Nenhum dado de armadilhas fotográficas disponível para exportar",
        );
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(
        translatedData,
        CAMERA_TRAPS_EXPORT_HEADS,
      );
      exportToCSV(
        formattedData,
        `relatorio_armadilhas_fotograficas_${actualDateTime()}`,
      );
      toast.success(
        "Relatório de armadilhas fotográficas exportado com sucesso!",
      );
    } catch {
      toast.error("Erro ao exportar relatório de armadilhas fotográficas");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
